/* tslint:disable */
/* eslint-disable */
/**
 * Yaway Workshop API
 * Yaway Workshop API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiAssistanceCaseSmsLinkCreateRequest
 */
export interface ApiAssistanceCaseSmsLinkCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiAssistanceCaseSmsLinkCreateRequest
     */
    phoneNumberPrefix: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAssistanceCaseSmsLinkCreateRequest
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ApiAssistanceCaseSmsLinkCreateRequest
     */
    licensePlate: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAssistanceCaseSmsLinkCreateRequest
     */
    serviceExternalId: number;
}

export function ApiAssistanceCaseSmsLinkCreateRequestFromJSON(json: any): ApiAssistanceCaseSmsLinkCreateRequest {
    return ApiAssistanceCaseSmsLinkCreateRequestFromJSONTyped(json, false);
}

export function ApiAssistanceCaseSmsLinkCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiAssistanceCaseSmsLinkCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phoneNumberPrefix': json['phoneNumberPrefix'],
        'phoneNumber': json['phoneNumber'],
        'licensePlate': json['licensePlate'],
        'serviceExternalId': json['serviceExternalId'],
    };
}

export function ApiAssistanceCaseSmsLinkCreateRequestToJSON(value?: ApiAssistanceCaseSmsLinkCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phoneNumberPrefix': value.phoneNumberPrefix,
        'phoneNumber': value.phoneNumber,
        'licensePlate': value.licensePlate,
        'serviceExternalId': value.serviceExternalId,
    };
}

